import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { Button } from "react-bootstrap";

const ConfirmationDialog = ({
  open,
  handleClose,
  handleConfirm,
  message,
  isLoading = false,
  cancelBtnText = "Cancel",
  confirmBtnText = "Confirm",
}) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            disabled={isLoading}
            style={{
              backgroundColor: "transparent",
              color: "rgba(34, 75, 153, 1)",
            }}
          >
            {cancelBtnText}
          </Button>
          {isLoading ? (
            <div className="w-20">
              <CircularProgress />
            </div>
          ) : (
            <Button onClick={handleConfirm} className="">
              {confirmBtnText}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmationDialog;
